import { Note } from "../Models/Note";
import * as React from "react";
import { FaRegEdit, FaTrash} from "react-icons/fa";
import { Button } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
interface IProps extends RouteComponentProps {
    note: Note;
    onNoteDelete: (id: string | undefined) => void;
    onNoteEdit: (id: string | undefined) => void;
}

export const NoteCard = (props: IProps): JSX.Element => {
    const { note, onNoteDelete, onNoteEdit, history } = props;
    return (
        <div id="noteList" className="card">
            <div className="card-body">
                <h5 className="card-title">{note.title}</h5>
                {note.tags?.map((tag) => (
                    <span className="card-subtitle">{tag.name}</span>
                ))}
                <p className="card-text">{note.post}</p>
                <div className="card-buttons">
                    <Button
                        variant="light"
                        onClick={(e:React.MouseEvent<HTMLElement, MouseEvent>) => {
                            e.preventDefault();
                            onNoteEdit(note.id);
                            history.push("/edit", props.location);
                        }}
                    >
                        <FaRegEdit />
                    </Button>

                    <Button
                        variant="light"
                        onClick={(e:React.MouseEvent<HTMLElement, MouseEvent>) => {
                            e.preventDefault();
                            onNoteDelete(note.id);
                        }}
                    >
                        <FaTrash />
                    </Button>

                    {/* <Button variant="light">
                        <FaEye />
                    </Button> */}
                </div>
            </div>
        </div>
    );
};
